var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1071.2 1220.6",
    style: {
      enableBackground: "new 0 0 1071.2 1220.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CE99E7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1045.3,1075.3v90.7h-73.9v-90.7h-90.7v-73.9h90.7v-92.1h73.9v92.1h25.8V0H888.4c-12.7,69-42.8,119-90.5,150 c-47.7,31-112.9,46.5-195.7,46.5h-22.4v162.1h243.1v862h248.3v-145.3H1045.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.1,358.6H0V196.5h22.4c82.8,0,148-15.5,195.7-46.5c47.7-31,77.9-81,90.5-150h182.7v1220.6H243.1V358.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo11);
export default __webpack_public_path__ + "static/media/no-11.1dadc0122233089dfbc14d6edaebfc7d.svg";
export { ForwardRef as ReactComponent };